// Copyright 2026. WebPros International GmbH. All rights reserved.

import Status, { StatusType } from 'common/components/Status/Status';
import { Translate } from '@plesk/ui-library';
import {
    ItemContainer,
    ItemValue,
} from 'common/components/StatusesList/Styles';

export interface IStatusesListItem {
    status: StatusType;
    labelKey: string;
    value: number;
    to?: string;
}

interface IProps {
    items: IStatusesListItem[];
}

export default function StatusesList({ items }: IProps) {
    return (
        <div>
            {items.map((item) => (
                <ItemContainer key={item.labelKey}>
                    <Status
                        value={item.status}
                        label={<Translate content={item.labelKey} />}
                        to={item.to}
                    />

                    <ItemValue>{item.value}</ItemValue>
                </ItemContainer>
            ))}
        </div>
    );
}
